module.exports = __webpack_public_path__ + "img/DAGEST.a6edac9b.png";